import { createReducer } from '@reduxjs/toolkit';

import { contractSetupDraftFetched } from '@app/store/contract-setup/actions';
import { setupTemplateByDraft } from '@app/store/template/actions';

const reducer = createReducer<Array<string> | null>(null, (builder) => {
  builder
    .addCase(
      contractSetupDraftFetched.type,
      (_state, action: ReturnType<typeof contractSetupDraftFetched>) =>
        action.payload.keywords || null
    )
    .addCase(setupTemplateByDraft, (_state, action) => action.payload.keywords || null);
});
export default reducer;
